/**
 * Display-only: keep first 2 decimal digits (truncate, no round).
 * e.g. 10.4477 → "10.44", 10.44775 → "10.44"
 */
function truncateMoney2(amount) {
    const value = Number(amount);
    if (!Number.isFinite(value)) return '0.00';
    const neg = value < 0;
    // Stabilize float noise, then chop to 2 dp (do not round)
    const raw = Math.abs(value).toFixed(8);
    const [intPart, decPart = ''] = raw.split('.');
    return `${neg ? '-' : ''}${intPart}.${(decPart + '00').slice(0, 2)}`;
}

/** Whole-taka display for grand total / due / change after invoice rounding. */
function formatGrossMoney(amount) {
    const value = Number(amount);
    if (!Number.isFinite(value)) return '0';
    return String(Math.round(value));
}

function getImageUrl(path) {
    const baseUrl = window.API_HOST_URL;
    const defaultImage = `${baseUrl}/media/default/default_img.jpg`;

    // null / undefined
    if (!path) {
        return defaultImage;
    }

    // If array
    if (Array.isArray(path)) {
        if (path.length === 0) {
            return defaultImage;
        }

        // take first image object
        path = path[0].small_thumb || path[0].image;
    }

    // If object
    if (typeof path === 'object' && path !== null) {
        path = path.small_thumb || path.image;
    }

    // Final safety check
    if (typeof path !== 'string') {
        return defaultImage;
    }

    return path.startsWith('http')
        ? path
        : `${baseUrl}${path}`;
}

/** Picker/cart row image: a variant's own photo, otherwise the item's photos. */
function getRowImageUrl(row) {
    if (row?.variant_id && (row.small_thumb || row.image)) {
        return getImageUrl(row.small_thumb || row.image);
    }
    return getImageUrl(row?.images);
}

/** Today's date as YYYY-MM-DD in the browser's local timezone (toISOString() is UTC). */
function todayLocal() {
    const d = new Date();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mm}-${dd}`;
}

export {
    todayLocal,
    getImageUrl,
    getRowImageUrl,
    truncateMoney2,
    formatGrossMoney,
}
